/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { action, computed } from '@ember/object';
import TagModel from 'cio/models/tag';
import { tracked } from '@glimmer/tracking';
import DS from 'ember-data';
import ArrayProxy from '@ember/array/proxy';
import { isEmpty } from '@ember/utils';

interface TagFilterArgs {
  selectedTagIds: string[];
  onTagIdsChange: (tagIds: string[]) => unknown;
  disabled?: boolean;
  dropdownClass?: string;
  triggerId?: string;
  placeholder?: string;
  horizontalPosition?: string;
}

export default class TagFilter extends Component<TagFilterArgs> {
  @service store!: DS.Store;

  @tracked showTagModal = false;
  @tracked tags: TagModel[] | ArrayProxy<TagModel> = [];

  get disabled() {
    return this.args.disabled ?? false;
  }

  get placeholder() {
    if (isEmpty(this.args.placeholder)) {
      return 'Filter by tags…';
    }

    return this.args.placeholder;
  }

  @computed('tags.@each.{id,name}')
  get dropdownOptions() {
    return (this.tags ?? []).map((tag) => ({
      value: tag.id,
      label: tag.name,
    }));
  }

  getTags = task({ drop: true }, async () => {
    try {
      this.tags = await this.store.findAll('tag');
    } catch {}
  });

  @action
  openTagModal() {
    this.showTagModal = true;
  }

  @action
  onChange(items: unknown[]) {
    this.args.onTagIdsChange(items.map((item: Record<string, any>) => item.value));
  }
}
